@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.rate-list-item {
  position: relative;
  background: @rate-viewer-rate-list-item--background-color;
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: @rate-viewer-rate-list-item--hover--background-color;
  }

  &.selected {
    background: @rate-viewer-rate-list-item--selected--background-color;

    &:after {
      content: '';
      position: absolute;
      z-index: 1;
      inset: 0;
      border: 2px solid @rate-viewer-rate-list-item--selected--border-color;
    }
  }
  > * {
    position: relative;
    z-index: 2;
  }
}

.rate-information {
  max-width: 80%;
}

.rate-name {
  .truncate();
  font-size: 16px;
  max-width: 100%;
  color: @rate-viewer-rate-list-item--name--text-color;
  line-height: 18px;
}

.rate-meta {
  color: @rate-viewer-rate-list-item--meta--text-color;
  font-size: 12px;
  margin-top: 3px;
}

.rate-value {
  color: @rate-viewer-rate-list-item--value--text-color;
  font-size: 16px;
  margin-left: 10px;
}
